import Vue from 'vue'
import VueBottomNavigation from "bottom-navigation-vue"

Vue.use(VueBottomNavigation)

export default {
  components: {
    VueBottomNavigation
  }
}